/* oxlint-disable typescript/naming-convention */
const deserialize = (data: string) => {
  try {
    return JSON.parse(data);
  } catch {
    return [];
  }
};

export const getAccountsFromLocalStorage = (key: string) => {
  const storage = window.localStorage;
  const data = storage.getItem(key);
  return data !== null ? deserialize(data) : [];
};

export enum localStorageKeys {
  FAVORITED = 'favoritedVitalstatistixAccounts',
  RECENTLY_VIEWED = 'recentlyViewedVitalstatistixAccounts',
}

export const getRecentlyViewedAccounts = () => getAccountsFromLocalStorage(localStorageKeys.RECENTLY_VIEWED);

export const getFavoritedAccounts = () => getAccountsFromLocalStorage(localStorageKeys.FAVORITED);
